export const ADP_LOCKED_FIELDS = new Set([
    "firstName", "lastName", "middleName", "preferredName",
    "dateOfBirth", "gender", "maritalStatus", "title",
    "personalEmail", "personalPhone", "phone",
    "residentialAddress", "residentialAddressLine1", "residentialAddressLine2",
    "residentialCity", "residentialState", "residentialCountry", "residentialPincode",
    "residentialDistrict", "residentialLat", "residentialLng",
    "permanentAddress", "permanentAddressLine1", "permanentAddressLine2",
    "permanentCity", "permanentState", "permanentCountry", "permanentPincode",
    "permanentDistrict", "permanentLat", "permanentLng",
    "baseSalary", "currency", "hireDate", "employeeType", "designation", "workLocation",
    "ssn", "drivingLicence", "dlExpiry", "dlStateOfIssue",
    "bankAccountNumber", "bankIfscCode", "bankName", "bankBranchName", "bankAccountHolderName",
    "panNumber", "aadhaarNumber", "esiNumber", "uanNumber",
    "nationality", "passportNumber", "passportExpiry", "visaType", "visaExpiry", "workAuthStatus",
]);
//# sourceMappingURL=adpFields.js.map